export default __webpack_public_path__ + "static/media/Dr-Shruthi-C.bbe3e231.jpg";